import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=cdb31f6a"
import script from "./ContentBlock.vue?vue&type=script&lang=ts"
export * from "./ContentBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports